import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

/**
 * Restricted rich-text editor for Forms Library long-form instructional
 * text (template description, intro_text, text_block help_text). Same
 * toolbar/format allow-list as lib/formsRichText.js's FORMS_ALLOWED_TAGS
 * — keep the two in sync if either changes.
 */
const QUILL_MODULES = {
  toolbar: [
    [{ header: [3, 4, false] }],
    ["bold", "italic"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["clean"],
  ],
};
const QUILL_FORMATS = ["header", "bold", "italic", "list", "bullet"];

export function FormsRichTextEditor({ value, onChange, placeholder, testId }) {
  return (
    <div data-testid={testId}>
      <ReactQuill theme="snow" value={value || ""} onChange={onChange} placeholder={placeholder}
                  modules={QUILL_MODULES} formats={QUILL_FORMATS} />
    </div>
  );
}
